<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
  </cTable>
</template>

<script>
import { add, getAirport, getDetails, update, del } from "@/api/system/circuit";
import { getCountry } from "@/api/system/country";
import cTable from "@/base/common/index";
export default {
  name: "circuit",

  components: {
    cTable,
  },
  async mounted() {
    // const to_country = (await getCountry({ allow_arrive: 1 })).data.payload
    // 				.rows;
    // this.header.searchs.forEach(item=>{
    // 	if (item.key === "to_country") item.options = to_country;
    // })
    // this.modals.add.fields.forEach(item=>{
    // 	if (item.key === "to_country") item.options = to_country;
    // })
  },
  data() {
    return {
      methods: {
        list: getAirport,
        getDetails,
        del,
        add,
        update,
      },
      config: {
        height: 630,
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page.handleRequestMethods(this.type, data).then((res) => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg,
                });
                this.$page.getList();
                close();
              });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              deliver_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                  type: "string",
                },
              ],
            },
          },
          grid: [
            { circuit: 24 },
            { output_port: 24 },
            { deliver: 24 },
            { watermark: 24 },
          ],
          fields: [
            {
              name: () => this.$tz("分拣口"),
              key: "output_port",
              component: "Input",
              placeholder: () => this.$tz("分拣口"),
            },
            {
              name: () => this.$t("circuit"),
              key: "circuit",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("circuit");
              },
            },
            {
              name: () => this.$t("systemDeliveryParty"),
              key: "deliver",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("systemDeliveryParty");
              },
            },
            {
              name: () => this.$t("LabelWatermark"),
              key: "watermark",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("LabelWatermark");
              },
            },
          ],
        },
      },
      header: {
        config: {
          custom: false,
        },
        searchs: [
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          },
          // {
          //   key: "ClientId",
          //   type: "select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("clientName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" }
          // }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning",
              },
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
        },
        {
          name: () => this.$t("circuit"),
          key: "circuit",
          align: "center",
        },
        {
          name: () => this.$tz("分拣口"),
          key: "output_port",
        },
        {
          name: () => this.$t("systemDeliveryParty"),
          key: "deliver",
          align: "center",
        },
        {
          name: () => this.$t("LabelWatermark"),
          key: "watermark",
          align: "center",
        },
        {
          name: () => this.$t("addTime"),
          key: "create_time",
          align: "center",
        },
        {
          name: () => this.$t("upTime"),
          key: "update_time",
          align: "center",
        },
        {
          type: "btns",
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          // width({ field }) {
          //   return field.list.length * 40 + 40;
          // },
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success",
              },
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "delete",
              // bind: {
              //   type: "error"
              // }
            },
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then((res) => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then((res) => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg,
                    });
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
